import { get } from 'lodash';

const toTrimGroups = (trims, options, styles) =>
  trims.map((trimName) => {
    const trimOptions = options.filter(
      (option) => option.trimName === trimName
    );
    const rearWheelType = get(trimOptions[0], 'rearWheelType') || '';
    return {
      trimName,
      options: trimOptions,
      cgi: get(
        styles.find((style) => style.trimName === trimName),
        'cgi'
      ),
      cgiTransparent: get(
        styles.find((style) => style.trimName === trimName),
        'cgiTransparent'
      ),
      rearWheelType: rearWheelType,
    };
  });

export default toTrimGroups;
